/**
 * Pure function to construct Cloudinary image URLs with auto format.
 * Equivalent to: cloudinary.image(imageId).delivery(format(auto())).toURL()
 * but without requiring the useCloudinary() hook.
 */
export function cloudinaryImageUrl(imageId: string): string {
  return `https://res.cloudinary.com/${process.env.CLOUDINARY_CLOUD_NAME}/image/upload/f_auto/${imageId}`;
}
